<div class="step-indicator">
    <div class="steps-container">
        <ng-container *ngFor="let step of steps; let i = index; let last = last">
            <div class="step" [class.completed]="isStepCompleted(step.number)" 
                             [class.active]="isStepActive(step.number)"
                             [class.pending]="isStepPending(step.number)">
                <div class="step-circle">{{ step.number }}</div>
                <div class="step-label">{{ step.label }}</div>
            </div>
            <div class="step-connector" *ngIf="!last"
                 [class.completed]="isStepCompleted(step.number + 1)"
                 [class.active]="isStepActive(step.number + 1)">
            </div>
        </ng-container>
    </div>
</div>
